import { createQueryKeys, type inferQueryKeys } from '@lukemorales/query-key-factory';
import { getVerifyUserId } from './mapper';

export const signupQueryKey = createQueryKeys('signup', {
  verifyId: (id: string) => ({
    queryFn: async () => {
      const data = await getVerifyUserId(id);
      return data;
    },
    queryKey: [{ id }],
  }),
});

export type SignupQueryKey = inferQueryKeys<typeof signupQueryKey>;
